import { render, staticRenderFns } from "./PassingPage.vue?vue&type=template&id=7166077a&"
import script from "./PassingPage.vue?vue&type=script&lang=js&"
export * from "./PassingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports